import useReminderNotifications from '$tablet-app/src/app/reminders/useReminderNotifications';
import { useStateStore } from '$tablet-app/src/app/stores/useStateStore';
import useCurrentDay from '$tablet-app/src/app/utils/useCurrentDay';
import { useListEventsByHabitatQuery } from '@akin-home/events/react';
import { useHabitatID } from '@akin-home/habitats/react';
import { addDays, endOfDay, isSameDay, startOfDay } from 'date-fns';
import { useEffect, useMemo } from 'react';

interface Props {
  children: JSX.Element;
}

export const EventOccurenceProvider = ({ children }: Props) => {
  const habitatID = useHabitatID();
  const day = useCurrentDay();

  /** Initiates the start of alert notifications */
  useReminderNotifications({ habitatID });

  const { start_of_today, end_of_tomorrow } = useMemo(() => {
    const today = new Date(day);

    return {
      start_of_today: startOfDay(today),
      end_of_tomorrow: endOfDay(addDays(today, 1)),
    };
  }, [day]);

  const { data: events } = useListEventsByHabitatQuery({
    habitatID,
    filter: {
      from: start_of_today.toISOString(),
      to: end_of_tomorrow.toISOString(),
    },
  });

  useEffect(() => {
    /** Just call this when we need it */
    useStateStore
      .getState()
      .loadTodaysEvents(
        events?.filter((ev) => isSameDay(ev.start, new Date())) || []
      );
  }, [events]);

  useEffect(() => {
    useStateStore.getState().startEventOccurenceTimers();
  }, []);

  return children;
};
